// Chowa シリーズ・モデル定義
// 新規モデル追加時はこのファイルのみを編集

export const CHOWA_SERIES = {
  HV: {
    name: 'HVシリーズ',
    color: '#3b82f6', // ブルー
    models: ['HV-300', 'HV-600']
  },
  SR: {
    name: 'SRシリーズ', 
    color: '#f97316', // オレンジ
    models: ['SR-60', 'SR-45', 'SR-30', 'SR-50']
  },
  ZV: {
    name: 'ZVシリーズ',
    color: '#9333ea', // パープル
    models: ['ZV-35H']
  }
};

// 全シリーズの配列（サイドバー用）
export const SERIES_LIST = Object.keys(CHOWA_SERIES).map(seriesKey => ({
  key: seriesKey,
  ...CHOWA_SERIES[seriesKey]
}));

// 全モデルの配列（ダッシュボード用）
export const ALL_MODELS = Object.values(CHOWA_SERIES).flatMap(series => 
  series.models.map(model => ({
    name: model,
    series: Object.keys(CHOWA_SERIES).find(key => CHOWA_SERIES[key].models.includes(model)),
    color: Object.keys(CHOWA_SERIES).find(key => CHOWA_SERIES[key].models.includes(model)) 
      ? CHOWA_SERIES[Object.keys(CHOWA_SERIES).find(key => CHOWA_SERIES[key].models.includes(model))].color 
      : '#6b7280'
  }))
);

// シリーズキーからモデル一覧を取得
export const getModelsBySeries = (seriesKey) => {
  return CHOWA_SERIES[seriesKey]?.models || [];
};

// モデル名からシリーズ情報を取得
export const getSeriesByModel = (modelName) => {
  for (const [seriesKey, seriesData] of Object.entries(CHOWA_SERIES)) {
    if (seriesData.models.includes(modelName)) {
      return {
        key: seriesKey,
        ...seriesData
      };
    }
  }
  return null;
};

// シリーズキーから色を取得
export const getSeriesColor = (seriesKey) => {
  return CHOWA_SERIES[seriesKey]?.color || '#6b7280';
};

// モデル名から色を取得
export const getModelColor = (modelName) => {
  const series = getSeriesByModel(modelName);
  return series?.color || '#6b7280';
}; 